// One row per token was fine while signing in anywhere revoked everything
// else. Sessions now survive each other, so a person who works across two
// apps and a phone has a handful at once and the table became a wall of the
// same name. Group by person; the individual sessions are still there to
// expand, and logging out has always been per person anyway.

const time = (value) => String(value || "");

export function groupSessions(sessions = []) {
  const byUser = new Map();

  sessions.forEach((s) => {
    const key = s?.userId ?? `${s?.email || ""}`;
    if (!byUser.has(key)) {
      byUser.set(key, {
        key,
        userId: s?.userId,
        name: s?.name,
        email: s?.email,
        role: s?.role,
        sessions: [],
      });
    }
    byUser.get(key).sessions.push(s);
  });

  return [...byUser.values()]
    .map((row) => {
      const ordered = row.sessions
        .slice()
        .sort((a, b) => time(b.createdAt).localeCompare(time(a.createdAt)));
      const active = ordered.filter((s) => s.active);
      return {
        ...row,
        sessions: ordered,
        activeCount: active.length,
        total: ordered.length,
        // The newest sign-in that still counts, so a stale row doesn't claim
        // the person is here.
        latestActiveAt: active.length ? active[0].createdAt : null,
      };
    })
    .sort(
      (a, b) =>
        b.activeCount - a.activeCount ||
        time(b.latestActiveAt).localeCompare(time(a.latestActiveAt)) ||
        String(a.name || "").localeCompare(String(b.name || ""))
    );
}

/** "18 active sessions across 5 people" — the count alone hid the pile-up. */
export function summariseSessions(sessions = []) {
  const active = sessions.filter((s) => s?.active);
  const people = new Set(active.map((s) => s?.userId ?? s?.email)).size;
  const sessionWord = `${active.length} active session${active.length === 1 ? "" : "s"}`;
  if (active.length === 0 || active.length === people) return sessionWord;
  return `${sessionWord} across ${people} ${people === 1 ? "person" : "people"}`;
}

/** "22 Sep, 13:07" — a session's age matters more than its date. */
export function formatSessionTime(value) {
  const raw = String(value || "");
  if (!raw) return "—";
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
